// Dependency
import React from "react"
import { Link } from "gatsby";


// Internationalization
import { useTranslation } from 'react-i18next';

// Hooks

// Styles
import * as ProductCardStyles from './product-card.module.scss'

// Assets
import * as productStyles from "../../templates/product/product.module.scss";


// Templates
const SearchProductCard = ({ product, color, labelBackground, labelText }) => {

    const prod = product
    const { t } = useTranslation();


    let buyButton = t('productCard.addToCart');

    // if ( data.slug && data.slug === 'flowfeet'  ) {
    //   buyButton = t('productInfo.preOrder')
    // }

    const discountPercent = Math.round((prod.oldPrice - prod.price) / prod.oldPrice * 100)
    const roundedDiscount = Math.round(discountPercent)

    return (
        <article className={` ${ProductCardStyles.cdProductCard} cd-product-card`}>
            <div className={`${ProductCardStyles.cdProductCardImg} cd-background-img`}>
                <img src={prod.imgUrl + '?h=600'} alt={prod.title} />
                {roundedDiscount > 0 ?
                    <span style={{ color: color, backgroundColor: labelBackground }} className={ProductCardStyles.cdProductSale}>
                        {labelText ? labelText : `Sale` }
                    </span>
                    : ''
                }
            </div>

            <div className={`${ProductCardStyles.cdProductCardContent} cd-product-card-content cd-dark-mode-dark`} >
                <div className={ProductCardStyles.cdProductCardContentLeft}>
                    <div className={ProductCardStyles.cdProductCardTitle}>
                        {prod && prod.title && <h2 className="">{prod.title}</h2>}
                    </div>


                </div>
                <div className={ProductCardStyles.cdProductCardContentRight}>
                    <div className={`${ProductCardStyles.cdProductPrice} cd-product-price`}>
                        <span className={`${prod.oldPrice !== prod.price ? 'cd-price-red' : ''} cd-product-price-value`}>{`${prod.price} ${prod.currency}`}</span>
                    </div>
                    {prod && prod.oldPrice !== prod.price ?
                        <div className={`${ProductCardStyles.cdProductOriginalPrice} cd-product-price-original`}>
                            <span className="cd-product-price-value">{prod && `${prod.oldPrice} ${prod.currency}`}</span>
                        </div> : ''}

                    {roundedDiscount > 0 ?
                        <span className={ProductCardStyles.cdProductPriceDiscount}> -{roundedDiscount}%</span>
                        : ''
                    }
                </div>
            </div>
            <Link to={`${prod.url.split('https://www.flowlife.com')[1]}`} className="cd-absolute-link"></Link>
        </article>
    )
}

export default SearchProductCard